import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { BRAND } from "../mock";

const WhatsAppIcon = ({ size = 28 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="#fff" viewBox="0 0 256 256">
    <path d="M152.58,145.23l23,11.48A24,24,0,0,1,152,176a72.08,72.08,0,0,1-72-72A24,24,0,0,1,99.29,80.46l11.48,23L101,118a8,8,0,0,0-.73,7.51,56.47,56.47,0,0,0,30.15,30.15A8,8,0,0,0,138,155ZM232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-40,24a8,8,0,0,0-4.42-7.16l-32-16a8,8,0,0,0-8,.5l-14.69,9.8a40.55,40.55,0,0,1-16-16l9.8-14.69a8,8,0,0,0,.5-8l-16-32A8,8,0,0,0,104,64a40,40,0,0,0-40,40,88.1,88.1,0,0,0,88,88A40,40,0,0,0,192,152Z" />
  </svg>
);

export const FinalCTA = () => {
  const scrollTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <section className="bg-[#0B1533]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-white leading-tight">
            {BRAND.name}
          </h2>
          <p className="font-body text-white/60 mt-4 text-lg max-w-md">
            Sichern Sie sich in Sekunden einen transparenten Fixpreis — ganz ohne Konto.
          </p>
        </div>
        <a
          href="/booking"
          className="group inline-flex items-center gap-3 bg-[#2B4BFF] text-white font-body font-semibold text-base rounded-full px-9 py-4 hover:bg-[#1E38D8] transition-all duration-200"
        >
          Transfer buchen
          <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-200" />
        </a>
      </div>
    </section>
  );
};

export const FloatingButtons = () => (
  <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform duration-200"
    >
      <WhatsAppIcon size={28} />
    </a>
    <a
      href={BRAND.phoneHref}
      aria-label="Call"
      className="w-14 h-14 rounded-full bg-[#2B4BFF] flex items-center justify-center shadow-[0_10px_30px_rgba(43,75,255,0.45)] hover:scale-105 transition-transform duration-200"
    >
      <Phone size={26} className="text-white" />
    </a>
  </div>
);
